import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import { Hero, Section, SectionHeader } from "@/components/layout/Sections";
import BookingForm from "@/components/BookingForm";

export default function MotoOfficina() {
  return (
    <PageLayout>
      <Hero
        image="/officina/img1.jpg"
        eyebrow="Moto · Officina"
        title="Esperienza a 360°: l'officina al lavoro"
        subtitle="Multibrand, con ricambi originali KTM e Husqvarna Motorcycles."
      />

      <Section>
        <div className="grid md:grid-cols-5 gap-10 md:gap-16 items-start">
          <div className="md:col-span-3">
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">Officina moto</span>
            <h2 className="font-display uppercase tracking-tight text-4xl md:text-5xl mt-3 leading-[0.95]">
              Manutenzione,<br />riparazioni & revisioni
            </h2>
            <div className="mt-6 aspect-[4/3] bg-cover bg-center" style={{ backgroundImage: "url(/officina/img4.jpg)" }} />
          </div>
          <div className="md:col-span-2 text-gray-700 leading-relaxed space-y-4">
            <p>
              La nostra officina lavora sul <strong>multibrand</strong>: manutenzioni, riparazioni meccaniche ed
              elettroniche, cambio gomme e revisioni.
            </p>
            <p>
              Siamo <strong>autorizzati</strong> a effettuare tutte le manutenzioni necessarie legate ai marchi
              <strong> KTM</strong> e <strong>Husqvarna Motorcycles</strong>, street e off-road, utilizzando ricambi ufficiali.
            </p>
            <p>
              La nostra esperienza spazia su tutte le tipologie di moto: <strong>enduro, cross, minicross, naked e travel</strong>,
              oltre alle e-bike.
            </p>
          </div>
        </div>

        {/* Gallery officina */}
        <div className="mt-16 grid md:grid-cols-2 gap-4 md:gap-6">
          <div className="aspect-[4/3] bg-cover bg-center" style={{ backgroundImage: "url(/officina/img2.jpg)" }} data-testid="officina-photo-2" />
          <div className="aspect-[4/3] bg-cover bg-center" style={{ backgroundImage: "url(/officina/img3.jpg)" }} data-testid="officina-photo-3" />
        </div>
      </Section>

      <Section tone="gray">
        <div className="grid md:grid-cols-3 gap-6">
          <Card
            eyebrow="Usato controllato"
            title="Controlli rigorosi sull'usato"
            body="Valutiamo il ritiro di moto usate di tutte le marche e cilindrate. Prima della vendita eseguiamo revisioni e controlli rigorosi per garantire moto sempre in perfetto stato."
          />
          <Card
            eyebrow="Personalizzazione"
            title="Personalizza la tua moto"
            body="Utilizziamo i Technical Accessories Husqvarna Motorcycles per ottenere il miglior risultato ed il massimo delle prestazioni."
          />
          <Card
            eyebrow="Diagnosi ufficiale"
            title="Tagliandi garantiti Husqvarna"
            body="Software diagnostico ufficiale Husqvarna Motorcycles: tagliandi e interventi registrati automaticamente sul portale della casa madre, con ricambi originali validi come garanzia."
          />
        </div>
      </Section>

      <Section tone="dark">
        <div className="grid md:grid-cols-5 gap-10 md:gap-16 items-start">
          <div className="md:col-span-2 text-white">
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">Preventivo officina moto</span>
            <h2 className="font-display uppercase text-4xl md:text-5xl mt-3 leading-[0.95]">
              Prenota<br />un intervento
            </h2>
            <p className="mt-6 text-white/80 leading-relaxed max-w-md">
              Compila il modulo con data e fascia oraria: ti ricontattiamo per confermare l'appuntamento
              in officina moto.
            </p>
          </div>
          <div className="md:col-span-3">
            <BookingForm defaultSection="moto" />
          </div>
        </div>
      </Section>
    </PageLayout>
  );
}

function Card({ eyebrow, title, body }) {
  return (
    <div className="card-flat p-6">
      <span className="label-eyebrow text-[color:var(--nsa-orange)]">{eyebrow}</span>
      <h3 className="font-display uppercase text-2xl mt-2">{title}</h3>
      <p className="mt-3 text-gray-600 leading-relaxed">{body}</p>
    </div>
  );
}
